import axios from "@/libs/api.request";
export const getList = (params) => {
  return axios.request({
    url: "/finance/reimburse/name",
    method: "get",
    params,
  });
};

export const add = (data) => {
  return axios.request({
    url: '/finance/reimburse/name',
    method: "post",
		data
  });
};

export const update = (data) => {
  return axios.request({
    url: '/finance/reimburse/name/'+data.id,
    method: "put",
		data
  });
};

export const del = (data) => {
  return axios.request({
    url: '/finance/reimburse/name/'+data.id,
    method: "delete",
		data
  });
};